/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/** React library */
import React, { Component, createRef } from 'react';

/** React redux */
import store from 'features/store';

/** Moment */
import moment from 'moment-timezone';

/** Project library */
import { bidIcon, directIcon, image_thumbnail, onsiteIcon, loaderIcon, shippable } from 'shared/images/images';
import { isAuthorized } from 'shared/settings/auth';
import { getCountDown, getDays, getDurationBgColor, minTwoDigits, sortByList, titleCase } from 'shared/modifiers';
import { bidsSseEvent, bidsSseEventAdd } from 'shared/settings/apiconfig';
import { getBuyersUrl } from 'shared/http';
import { addDataLayer, getItemUrl } from 'shared/utils/utils';

/** State maintainance */
import {
    convertToMaintainData,
    disablePreviousState,
    getMaintainData,
    previousState,
    SaleCardView,
    enablePreviousState,
    removeStateMaintainValue
} from 'shared/settings/stateMaintain';

/** Previous, next handle */
import { notAllow, PreviousNextNotAllow } from '.';

/** Services */
import { CommonService, ItemsService } from 'shared/services';

/** Bootstrap */
import { Button, Row, Col, Modal, Spinner } from 'react-bootstrap';

/** react-virtualized */
import List from 'react-virtualized/dist/commonjs/List';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import 'react-virtualized/styles.css';

/** SSE Event */
import { SSE } from 'shared/sse';

/** Styles */
import './SaleCardViewDataTable.scss';
import { Adsense, AdsenseFiller } from 'shared/utils/Adsense';
import { ADSENSE } from 'shared/settings/config';
/**


@Author Karthik

@param

@return sale card view virtualized component

**/

export class SaleCardViewDataTable extends Component {
    constructor(props) {
        super(props);
        this.config = props.config;
        this.modalContainerRef = createRef();

        /** Item type images */
        this.itemsImage = {
            'item_image_1': directIcon,
            'item_image_2': bidIcon,
            'item_image_3': onsiteIcon,
        };

        /** Few variable's only using due to state maintanance */
        this.state = {
            duration: moment().add(13, 'days'),
            itemsList: [],
            pageLoading: true,
            innerWidth: window.innerWidth,
            watch: [],
            time: moment(),
            currentBidValue: [],
            reduceTime: 0,
            selectedItems: this.props.selectedwatchingitems || [],
            askConfirmForWatch: false,
            confirmLoader: false,
            selectedItemForDelete: null,
            oldTimer: null,
            nextList: null,
            loaderForMore: false,
            clickedItem: null,
            notUpdated: true,
            getCurrentBidValueStatus: "REQUEST",
            refreshData: {},
            commonUTCTime: null,
            timercal: 1,
            itemClosed: {},
            topCategories: [],
            keywords: '',
            showAdPossible: null
        };

        /** CountDown handling */
        this.getBidValueInterval = null;
        this.countdownInterval = null;
        this.eventSource = [];
        this.handleMultipleCall = {};
        this.adsenseFiller = new AdsenseFiller();
    }

    componentDidMount() {
        this.getItemsList();
        this.windowResizeHandle();
        window.addEventListener('resize', this.windowResizeHandle);
        document.addEventListener('visibilitychange', this.handleTabChange);
        this.getUtc();
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.config.postData) !== JSON.stringify(prevProps.config.postData)) {
            this.getItemsList();
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.setState({
                    reduceTime: 0,
                    timercal: 1
                }, () => {
                    this.updateTime();
                });
            } else {
                this.updateTime();
            }
        }
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.getWatchList();
        }
        document.addEventListener('visibilitychange', this.handleTabChange);
        window.addEventListener('resize', this.windowResizeHandle);
    }

    /** Every secs one it will call. This for handle timer. */
    updateTime = () => {
        this.countdownInterval = setInterval(() => {
            this.setState({
                time: moment(),
                reduceTime: this.state.reduceTime + 1,
                timercal: this.state.timercal + 1,
                oldTimer: this.state.oldTimer ? this.state.oldTimer + 1 : null,
                notUpdated: false
            });
            console.clear();
        }, 1000 * this.state.timercal);
    }

    /** Called when page resize.*/
    windowResizeHandle = () => {
        this.setState({
            innerWidth: window.innerWidth
        });
    }

    /**
     * To handle responsive.
     * 
     * @returns Number - either 2 or 3
     */
    noOfCloumnGet = () => {
        return this.state.innerWidth < 1271 ? 2 : this.state.innerWidth >= 1707 ? 3 : 3;
    }

    /**
     * Called when page render. 
     * Note:- This is shared component. So, sometimes trigger from parent component.
     * 
     * @param {boolean} append To handle pagination
     * 
     * @param {object} config Configuration
     */
    getItemsList = (append = false, config = {}) => {
        const allow = !notAllow.includes(this.props.history.location.pathname);
        const check = this.props.history.action === "POP" && this.props.previousPath.component === "itemview" && allow;
        if (check) {
            enablePreviousState();
        } else {
            removeStateMaintainValue([`${SaleCardView}${this.props.history.location.pathname}`]).then(res => res).catch(error => error);
            disablePreviousState();
        }
        removeStateMaintainValue([`ActiveItemIndex${this.props.history.location.pathname}`]).then(res => res).catch(error => error);

        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: null } });
        const previous = getMaintainData(previousState);
        if (previous && previous.apply && !append && !this.props.stopStateMaintain) {
            this.getPreviousValues();
        } else {
            if ('mode' in this.config.postData) {
                const data = {
                    data: {
                        ...this.config.postData.data
                    },
                    page: this.state.nextList ? { "size": 48, next: this.state.nextList } : { 'size': 48 }
                }
                // if(this?.props?.history?.location?.state){
                //     data["filter"] = [
                //         {
                //             "field": "zipcode",
                //             "op": "=",
                //             "value": this?.props?.history?.location?.state,
                //             "join": "AND"
                //         }
                //     ]
                // }
                ItemsService.itemsNLPSearch(data).then(
                    itemsList => {
                        const previuosItems = this.state.itemsList;
                        const temp = itemsList.data.data;
                        const tempNextList = itemsList.data.page && itemsList.data.page.keyset && itemsList.data.page.keyset.next ? itemsList.data.page.keyset.next : null; 
                        // const topCategories = itemsList.data.data.topcategories ? itemsList.data.data.topcategories : this.state.topCategories;
                        // const keyWords = itemsList.data.data.keywords ? itemsList.data.data.keywords : this.state.keywords;
                     
                        this.setState({
                            itemsList: append ? previuosItems.concat(temp) : temp,
                            pageLoading: false,
                            nextList: tempNextList,
                            loaderForMore: false,
                            // topCategories: topCategories,
                            // keywords: keyWords
                        }, () => {
                            this.emitData();
                            this.sseEventListener();
                            this.getWatchList();
                        });
                    }
                ).catch((error) => {
                    this.setState({
                        itemsList: [],
                        pageLoading: false,
                        // topCategories: [],
                        // keywords: ''
                    });
                    // this.props.getItemsList({ data: [], length:  0,  topCategories: [], keywords: '',serachFailed: true });
                });
            } else {
                const previuosItems = this.state.itemsList;
                const data = append && config.data ? config.data : this.props.config.postData;
                data["field"] = [
                    "id", "displayimageurl", "state", "city", "zipcode", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime",
                    "utc", "title", "endtime", "isshippable", "saleid", "category", 'categoryGroup','thumbnailurl', 'itemseourl'
                ];
                if (this.props.addClosingOrder) {
                    data.field.push('closingorder');
                }
                if (this.props.addItemlistingtime) {
                    data.field.push('itemlistingtime');
                }
                if (this.props.addBidCount) {
                    data.field.push('bidcount');  
                }
                if (this.props.addBidPrice && this.props.config.postData.sort[0]["field"] == 'bidprice') {
                    data.field.push('bidprice');  
                } 
                if (this.props.addEstateBidPrice) {
                    data.field.push('bidprice');  
                }
                if (this.props.showMoreButton) {
                    data["page"] = this.state.nextList ? { "size": 48, next: this.state.nextList } : { 'size': 48 };
                }
                if (this.props.addBidPrice) {
                    data.field.push('bidprice');
                }
                if (this.props.userSearchApi) {
                    ItemsService.searchItemList(data).then(
                        itemsList => {
                            const temp = this.props.sortBy ? sortByList({ itemArray: itemsList.data.data, key: "id" }, this.props.sortBy) : itemsList.data.data;
                            const tempNextList = itemsList.data.page && itemsList.data.page.keyset && itemsList.data.page.keyset.next ? itemsList.data.page.keyset.next : null;

                            this.setState({
                                itemsList: append ? previuosItems.concat(temp) : temp,
                                pageLoading: false,
                                nextList: tempNextList,
                                loaderForMore: false
                            }, () => {
                                this.emitData();
                                this.sseEventListener(append ? temp : null);
                                this.getWatchList(append ? temp : null);
                            });
                        }
                    ).catch((error) => {
                        this.setState({
                            itemsList: [],
                            pageLoading: false,
                        });
                    });
                } else {
                    ItemsService.getItemsList(data).then(
                        itemsList => {
                            let temp = this.props.sortBy ? sortByList({ itemArray: itemsList.data.data, key: "id" }, this.props.sortBy) : itemsList.data.data;
                            const tempNextList = itemsList.data.page && itemsList.data.page.keyset && itemsList.data.page.keyset.next ? itemsList.data.page.keyset.next : null;
                            // if ( this.props.showAd ) {
                            //     temp = this.adsenseFiller.getGoogleAdData(this.state.itemsList, temp, 16, 48, tempNextList ? false : true);
                            // }
                            this.setState({
                                itemsList: append ? previuosItems.concat(temp) : temp,
                                pageLoading: false,
                                nextList: tempNextList,
                                loaderForMore: false
                            }, () => {
                                this.emitData();
                                this.sseEventListener(append ? temp : null);
                                this.getWatchList(append ? temp : null);
                                this.props?.dataloaded && this.props?.dataloaded(this.state.itemsList)
                            });
                        }
                    ).catch((error) => {
                        this.setState({
                            itemsList: [],
                            pageLoading: false,
                        });
                    });
                }
            }
        }
    }

    /** State maintenance check. */
    getPreviousValues = () => {
        try {
            const itemsList = getMaintainData(`${SaleCardView}${this.props.history.location.pathname}`);
            if (itemsList && itemsList.itemsList.length > 0) {
                this.setState({
                    ...itemsList,
                    pageLoading: false,
                }, () => {
                    this.emitData(true);
                    this.sseEventListener();
                    this.getWatchList();
                    if (this.props.condition !== "watching") {
                        this.isItemRemoved();
                    }
                    disablePreviousState();
                });
            } else {
                disablePreviousState();
                this.getItemsList();
            }
        } catch (e) {
            disablePreviousState();
            this.getItemsList();
        }
    }

    /** Called when click more button*/
    getMoreList = () => {
        this.setState({
            loaderForMore: true,
        }, () => {
            this.getItemsList(true);
        })
    }

    /**
     * 
     * Called when click watch button. This will call remove api for remove item from watch list when already watch that item.
     * 
     * To add to watch list it will call add api. After success, it will add item in variable.
     * 
     * @param {*} event click event
     * 
     * @param {*} item item
     * 
     * @param {*} index To handle button focus.
     */
    watch = (event, item, index) => {
        event.stopPropagation();
        this[`buttonDOM_${index}`].blur();
        const itemId = item.id ? item.id : item.itemid;
        if (isAuthorized()) {
            const index = this.state.watch.findIndex(x => x.itemid === itemId);
            if (index !== -1) {
                this.setState({
                    selectedItemForDelete: itemId
                }, () => {
                    if (this.props.askConfirmForWatch) {
                        this.setState({
                            askConfirmForWatch: true
                        });
                    } else {
                        this.removeFromWatch();
                    }
                });

            } else {
                const addData = {
                    "data": [
                        {
                            "itemid": itemId
                        }
                    ]
                }
                ItemsService.addToWatch(addData).then(
                    response => {
                        const data = response.data.data[0];
                        const temp = { itemid: itemId, id: data.id };
                        const tempWatch = this.state.watch;
                        tempWatch.push(temp);
                        this.setState({
                            watch: tempWatch
                        });
                    }
                ).catch(error => {
                    // this.emitData();
                });
            }
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        }
        if(this.watching(item)){
            let dataLayerData = {
                'event': 'watch',
                'title': item.title,
            }
            addDataLayer(dataLayerData)
        }
    }

    /**
     * 
     * Called when click watch button. 
     * 
     * Note:- This fun never call directly. This is called from watch fun.
     * 
     * @param {boolean} flag to handle loader
     */
    removeFromWatch = (flag = false) => {
        this.setState({
            confirmLoader: flag
        });
        const itemId = this.state.selectedItemForDelete;
        const removeData = {
            "data": {
                "itemIds": [itemId]
            }
        };
        ItemsService.removeFromWatch(removeData).then(
            response => {
                this.closeConfirmModal();
                const index = this.state.watch.findIndex(x => x.itemid === itemId);
                const tempWatch = this.state.watch;
                tempWatch.splice(index, 1);
                this.setState({
                    watch: tempWatch
                });
                if (flag) {
                    this.removeFromList();
                }
            }
        ).catch(error => {
            this.emitData();
        });
    }

    /**
     * Called when page render
     * 
     * Note:- This is Auth API.
     * 
     * @param {*[]} appendList items list 
     */
    getWatchList = (appendList = null) => {
        this.getCurrentBidValue(appendList);
        if (isAuthorized()) {
            const itemsList = appendList ? appendList : this.state.itemsList;
            const itemId = [];
            itemsList.forEach(item => {
                itemId.push(item.id ? item.id : item.itemid);
            });
            if (itemsList.length > 0) {
                const data = {
                    "sort": [{ "field": "id", "direction": "desc" }],
                    "filter": [{ "field": "itemid", "value": [itemId], "op": "IN", "join": "AND" }],
                    "field": ["itemid"],
                    "page": { "size": itemsList.length + 1 }
                };
                ItemsService.getWatchListItem(data).then(
                    response => {
                        const tempWatch = appendList ? this.state.watch : [];
                        const watch = response.data.data;
                        this.setState({
                            watch: tempWatch.concat(watch)
                        })
                    }
                ).catch(error => {
                    // this.emitData();
                });
            }
        } else {
            this.setState({
                watch: []
            });
            // this.emitData();
        }
    }

    /**
     * called when page render or any bid happen.
     * 
     * Note:- This is public API.
     * 
     * @param {*[]} appendList items list
     */
    getCurrentBidValue = (appendList = null) => {
        const itemsList = appendList ? appendList : this.state.itemsList;
        const itemId = [];
        itemsList.forEach(item => {
            const check = item.id ? item.id : item.itemid;
            check ? itemId.push(check) : itemId.push(item);
        });
        const data = {
            "data": {
                "itemIds": itemId
            }
        }
        if (itemId.length > 0) {
            this.setState({ getCurrentBidValueStatus: "REQUEST" }, () => {
                ItemsService.getCurrentBidValue(data).then(
                    response => {
                        const tempCurrentBidValue = JSON.parse(JSON.stringify(this.state.currentBidValue));
                        const currentBidValue = response.data.data;
                        currentBidValue.forEach(x => {
                            const index = tempCurrentBidValue.findIndex(y => y.itemid === x.itemid);
                            if (index !== -1) {
                                tempCurrentBidValue.splice(index, 1);
                            }
                        });
                        this.setState({
                            getCurrentBidValueStatus: "SUCCESS",
                            currentBidValue: tempCurrentBidValue.concat(currentBidValue),
                        });
                    }
                ).catch(error => {
                    this.setState({
                        getCurrentBidValueStatus: "FAILURE",
                        refreshData: {
                            showModal: true,
                            func: this.getCurrentBidValue,
                            params: [appendList]
                        }
                    });
                });
            })

        }
    }

    /**
     * To get bidvalue based on item.
     * 
     * @param {*} item item
     * 
     * @returns number
     */
    getBidValue = (item) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemValue = this.state.currentBidValue.filter(x => x.itemid === itemId);
        return itemValue.length > 0 ? isNaN(itemValue[0].bidprice) ? 0 : itemValue[0].bidprice : 0;
    }

    /**
     * Check the items is watching by user
     * 
     * @param {*} items items
     * 
     * @returns boolen 
     */
    watching = (items) => {
        const itemId = items.id ? items.id : items.itemid;
        return this.state.watch.filter(x => x.itemid === itemId).length > 0;
    }

    getItemId = (item) => item?.id || item?.itemid;

    /**
     * Navigate when click item block
     * @param {*} item 
     */
    overAllClick = (item, index) => {
        const id = this.getItemId(item);
        let searchPath = this.props.history.location.pathname;

        const allow = !notAllow.includes(searchPath);
        if (allow) {
            if (this.props.stateMaintenance) {
                this.props.stateMaintenance();
            }
            convertToMaintainData(`${SaleCardView}${searchPath}`, {
                itemsList: this.state.itemsList,
                clickedItem: id,
                nextList: this.state.nextList,
                currentBidValue: this.state.currentBidValue,
                // keywords: this.state.keywords,
                // topCategories: this.state.topCategories
            });
        } else {
            convertToMaintainData(`${SaleCardView}${this.props.history.location.pathname}`, { itemsList: this.state.itemsList });
        }

        // ItemsService.addCountAPI(id).then(Res => Res).catch(err => err);

        let previousNextNotAllow = PreviousNextNotAllow.includes(searchPath);
        sessionStorage.setItem(`ActiveItemIndex${searchPath}`, previousNextNotAllow ? null : JSON.stringify(index));
        // previousNextNotAllow = searchPath.includes("advance-search/items") ? true : previousNextNotAllow;
        previousNextNotAllow ? this.props.history.push(getItemUrl(item.saleid, id, item.itemseourl)) : this.props.history.push({ pathname: getItemUrl(item.saleid, id, item.itemseourl), state: { searchPath: Buffer.from(searchPath).toString("base64") } });

        let dataLayerData = {
            'event': 'bid_now',
            'title': item.title
        }
        addDataLayer(dataLayerData)
    }

    /**
     * After get items or if items update will emit data
     */
    emitData = (scrollPage = false) => {
        if (this.props.getItemsList) {
            this.props.getItemsList({ data: this.state.itemsList, length: this.state.itemsList ? this.state.itemsList.length : 0, scrollPage: scrollPage });
        }
    }

    /**
     * 
     * Converting to end-time to moment duration
     * 
     * @param {*} item Items
     * 
     * @param {*} time Date
     * 
     * @returns Moment Duration  
     */
    countdown = (item, time) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemValue = this.state.currentBidValue.filter(x => x.itemid === itemId);
        const itemclosetime = itemValue.length > 0 ? itemValue[0].itemclosetime : null;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();

        const tempendtime = item.itemclosetime ? item.itemclosetime : item.endtime;
        const endtime = itemclosetime ? itemclosetime : tempendtime;
        const countdown = getCountDown(moment.utc(endtime), moment.utc().subtract(2, 'seconds'), false, utcTime);
        return countdown.diffDuration;
    }

    /**
     * Getting bg color based on time duration
     * 
     * @param {*} item Item
     * 
     * @param {*} time Date
     * 
     * @returns Background color
     */
    durationBgColor = (item, time) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemValue = this.state.currentBidValue.filter(x => x.itemid === itemId);
        const itemclosetime = itemValue.length > 0 ? itemValue[0].itemclosetime : null;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();

        const tempendtime = item.itemclosetime ? item.itemclosetime : item.endtime;
        const endtime = itemclosetime ? itemclosetime : tempendtime;
        const duration_bg_color = getDurationBgColor(endtime, moment.utc().subtract(2, 'seconds'), false, utcTime);
        return duration_bg_color;
    }

    /**
    * Getting number of days based on time duration
    * 
    * @param {*} item Item
    * 
    * @param {*} time Date
    * 
    * @returns Background color
    */
    numberDaysInWord = (item, time) => {

        const itemId = item.id ? item.id : item.itemid;
        const itemValue = this.state.currentBidValue.filter(x => x.itemid === itemId);
        const itemclosetime = itemValue.length > 0 ? itemValue[0].itemclosetime : null;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();

        const tempendtime = item.itemclosetime ? item.itemclosetime : item.endtime;
        const endtime = itemclosetime ? itemclosetime : tempendtime;
        const countdown = getCountDown(endtime, moment.utc().subtract(2, 'seconds'), false, utcTime);

        const duration = countdown.diffDuration;

        const check = duration.asSeconds() < 2 ? "Item closed" : null;
        const return_value = check ? check : duration.asMinutes() < 3 ? "Item is closing now" : 'Till item closes';

        return return_value;
    }

    /**
    * 
    * To check item is closed or not.
    * 
    * @param {*} item Item
    * 
    * @param {*} time Date
    * 
    * @returns True or false
    */
    itmeIsClosed = (item, time) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemValue = this.state.currentBidValue.filter(x => x.itemid === itemId);
        const itemclosetime = itemValue.length > 0 ? itemValue[0].itemclosetime : null;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();

        const tempendtime = item.itemclosetime ? item.itemclosetime : item.endtime;
        const endtime = itemclosetime ? itemclosetime : tempendtime;
        const countdown = getCountDown(moment.utc(endtime), moment.utc().subtract(2, 'seconds'), false, utcTime);
        const check = countdown.diffDuration.asSeconds() < 2;
        this.updatedStatus(item.itemstatus !== 'Pending' ? check : false, itemId);
        return check;
    }

    /**
     * 
    * To check item is have only one to close or not.
    * 
    * @param {*} item Item
    * 
    * @param {*} time Date
    * 
    * @returns True or false
    */
    betweenCheck = (item, time) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemValue = this.state.currentBidValue.filter(x => x.itemid === itemId);
        const itemclosetime = itemValue.length > 0 ? itemValue[0].itemclosetime : null;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();

        const tempendtime = item.itemclosetime ? item.itemclosetime : item.endtime;
        const endtime = itemclosetime ? itemclosetime : tempendtime;
        const countdown = getCountDown(moment.utc(endtime), moment.utc().subtract(2, 'seconds'), false, utcTime);
        const check = countdown.diffDuration.asMinutes() < 1;
        this.checkItemCloseTime(item, time, countdown);
        return check;
    }

    /**
     * 
     * Called when item reach zero secs
     * 
     * @param {*} item Item
     * 
     * @param {*} time Date
     * 
     * @param {*} countdown Diff duration (Moment duration) 
     */
    checkItemCloseTime = (item, time, countdown) => {
        const itemId = item.id ? item.id : item.itemid;
        if (countdown.diffDuration.asSeconds() === 1) {
            this.closeTimeCheck(itemId, true);
        }
    }

    /* SSE Event  */
    sseEventListener = (itemList) => {
        const items = itemList ? itemList : this.state.itemsList;
        try {
            if (items.length > 0) {
                let temp = items.map(x => x.id ? x.id : x.itemid);
                const position = itemList && this.eventSource.length === 0 ? this.eventSource.push(null) : 0;
                let now = moment().format('DD-MM-YYYY-HH-mm-ss');
                now = now ? now.replace(/-/g, '') : Math.floor(100000 + Math.random() * 900000);
                const number = Math.floor(100000 + Math.random() * 900000);
                const clientId = now + number.toString();

                this.eventSource[position] = new EventSource(`${getBuyersUrl(bidsSseEvent)}${clientId}`);
                this.eventSource[position].onmessage = (event) => this.updateBidValue(event);
                this.eventSource[position].onopen = (event) => this.postCall(event, clientId, temp);
                this.eventSource[position].onerror = (event) => { console.clear(); setTimeout(() => { console.clear(); }, 1000) };
            }
        } catch (e) {
            console.error(e);
        }
    }

    postCall = (event, clientId, temp) => {
        const headers = { "Content-Type": "application/json" };
        const PostCall = new SSE(`${getBuyersUrl(bidsSseEventAdd)}${clientId}`, { payload: JSON.stringify({ data: { itemIds: temp } }), headers });
        PostCall.stream();
    }

    /**
     * 
     * To to get UTC time. Called when page render or trigger from another fun.
     * 
     * @param {*} items item
     */
    getUtc = (items = null) => {
        this.setState({
            commonUTCTime: moment.utc(),
            reduceTime: 0
            // notUpdated: false
        }, () => {
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.setState({
                    reduceTime: 0,
                    timercal: 1
                }, () => {
                    this.updateTime();
                });
            } else {
                this.updateTime();
            }
            if (items) {
                this.getCurrentBidValue(items);
            }
        });
    }

    /**
     * 
     * Data emit
     * 
     * @param {*} items item
     */
    updateExtraDetails = (items) => {
        if (this.props.extraDetailsUpdate) {
            this.props.extraDetailsUpdate(items);
        }
    }

    /**
     * 
     * Called when trigger SSE event.
     * 
     * @param {*} event 
     */
    updateBidValue = (event) => {
        try {
            const data = JSON.parse(event.data);
            if (data.itemIds) {
                this.isItemRemoved(data.itemIds);
                this.getUtc(data.itemIds);
                this.updateExtraDetails(data.itemIds);
            }
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * 
     * To check item is selected or not.
     * 
     * Note:- Need to enable checkbox.
     * 
     * @param {*} item items
     * 
     * @returns boolean - True or False
     */
    isChecked = (item) => {
        return this.state.selectedItems.includes(item.id);
    }

    /**
     * 
     * To handle loader
     * 
     * @param {*} itemId 
     * 
     * @returns Value
     */
    checkIsCheckTime = (itemId) => {
        const checkingTimeHandle = `checkingTimeHandle_${itemId}`;
        const value = sessionStorage.getItem(checkingTimeHandle);
        return JSON.parse(value);
    }

    /**
     * 
     * Called when item reach zero secs.
     * 
     * @param {string|number} itemId item id
     * 
     * @param {boolean} withIntervel Wait for 7 secs to update value
     */
    closeTimeCheck = (itemId, withIntervel = false) => {
        const checkingTimeHandle = `checkingTimeHandle_${itemId}`;
        sessionStorage.setItem(checkingTimeHandle, true);
        if (withIntervel) {
            setTimeout(() => {
                this.checkAndUpdate(itemId);
                this.isItemRemoved([itemId]);
                this.getUtc([itemId]);
                this.updateExtraDetails([itemId]);
            }, 7000);
        } else {
            this.checkAndUpdate(itemId);
            this.isItemRemoved([itemId]);
            this.getUtc([itemId]);
            this.updateExtraDetails([itemId]);
        }
    }

    /**
     * Bid value going to zero when sse event faild or 2 secs bid.
     * To handle that using this fun. 
     * 
     * Note:- To handle timer, it will call itemsdetails API 
     *        when error occurred or No data available in BidAPI.
     * 
     * @param {string|number} itemId 
     */
    checkAndUpdate = (itemId) => {
        const data = {
            "data": {
                "itemIds": [itemId]
            }
        }
        this.setState({ getCurrentBidValueStatus: "REQUEST" }, () => {
            ItemsService.getCurrentBidValue(data).then(
                response => {
                    const tempCurrentBidValue = JSON.parse(JSON.stringify(this.state.currentBidValue));
                    const currentBidValue = response.data.data;
                    if (currentBidValue.length > 0) {
                        currentBidValue.forEach(x => {
                            const index = tempCurrentBidValue.findIndex(y => y.itemid === x.itemid);
                            if (index !== -1) {
                                tempCurrentBidValue.splice(index, 1);
                            }
                        });
                        this.setState({
                            getCurrentBidValueStatus: "SUCCESS",
                            currentBidValue: tempCurrentBidValue.concat(currentBidValue),
                        }, () => {
                            const checkingTimeHandle = `checkingTimeHandle_${itemId}`;
                            sessionStorage.setItem(checkingTimeHandle, false);
                        });
                    } else {
                        this.updateItemDetails(itemId);
                    }
                }
            ).catch(error => {
                const checkingTimeHandle = `checkingTimeHandle_${itemId}`;
                sessionStorage.setItem(checkingTimeHandle, false);
                this.updateItemDetails(itemId);
            });
        });
    }

    updateItemDetails = (itemId) => {
        const itemsDetailsGet = { "sort": [{ "field": "title", "direction": "asc" }] };
        const checkingTimeHandle = `checkingTimeHandle_${itemId}`;

        /* Getting item details */
        this.setState({ getCurrentBidValueStatus: "REQUEST" }, () => {
            ItemsService.getItemDetails(itemId, itemsDetailsGet).then(
                itemsDetail => {

                    const tempData = itemsDetail.data.data[0];
                    tempData['itemid'] = tempData['id'];
                    const tempCurrentBidValue = JSON.parse(JSON.stringify(this.state.currentBidValue));

                    const index = tempCurrentBidValue.findIndex(x => {
                        const itemid = x.id ? x.id : x.itemid;
                        return itemid === itemId;
                    });
                    index !== -1 ? tempData["bidprice"] = tempCurrentBidValue[index].bidprice : tempData["bidprice"] = 0;
                    index !== -1 ? tempCurrentBidValue[index] = tempData : tempCurrentBidValue.push(tempData);
                    sessionStorage.setItem(checkingTimeHandle, false);

                    this.setState({
                        getCurrentBidValueStatus: "SUCCESS",
                        currentBidValue: tempCurrentBidValue,
                        itemClosed: {
                            ...this.state.itemClosed,
                            [itemId]: false
                        }
                    }, () => {
                        const checkingTimeHandle = `checkingTimeHandle_${itemId}`;
                        sessionStorage.setItem(checkingTimeHandle, false);
                        this.handleMultipleCall[itemId] = false;
                    });
                }
            ).catch((error) => {
                // TODO: Error message handle
                this.setState({
                    getCurrentBidValueStatus: "FAILURE",
                    refreshData: {
                        showModal: true,
                        func: this.updateItemDetails,
                        params: [itemId]
                    }
                })
                sessionStorage.setItem(checkingTimeHandle, false);
            });
        });
    }

    /** This function called from either watching or bidding screen. */
    toggleSelectAll = (selectAll) => {
        const itemsList = this.state.itemsList;
        if (selectAll) {
            const temp = itemsList.map(x => x.id);
            this.setState({
                selectedItems: temp
            }, () => {
                this.emitWhenSelect();
            });
        } else {
            this.setState({
                selectedItems: []
            }, () => {
                this.emitWhenSelect();
            });
        }
    }

    /** This function called from either watching or bidding screen. */
    selectItem = (item) => {
        const index = this.state.selectedItems.findIndex(x => x === item.id);
        const temp = this.state.selectedItems;
        if (index === -1) {
            temp.push(item.id);
            this.setState({
                selectedItems: temp
            }, () => {
                this.emitWhenSelect();
            });
        } else {
            temp.splice(index, 1);
            this.setState({
                selectedItems: temp
            }, () => {
                this.emitWhenSelect();
            });
        }

    }

    /**
     * Called when select/unselect item (checkbox toggle).
     */
    emitWhenSelect = () => {
        const itemsList = this.state.itemsList;
        const selectedItems = this.state.selectedItems;
        if (this.props.selectedItems) {
            const final = {
                selectedItems: selectedItems,
                itemsList: itemsList,
                selectedAll: selectedItems.length === itemsList.length
            };
            this.props.selectedItems(final);
        }

    }

    closeConfirmModal = () => {
        this.setState({
            confirmLoader: false,
            askConfirmForWatch: false
        });
    }

    /**
     * 
     * Called when item remove from list.
     * 
     */
    removeFromList = () => {
        const itemsList = this.state.itemsList;
        const index = itemsList.findIndex(x => x.id === this.state.selectedItemForDelete);
        if (index !== -1) {
            itemsList.splice(index, 1);
            this.setState({
                itemsList: itemsList
            });
        }
    }

    /** using for handle watching and bidding screen data */
    getItemDetails = (item) => {
        const temp = this.props.watchingAndBiddingList.filter(x => x.itemid === item.id);
        return temp[0];
    }

    /** Won(winning) or Not won (Not winning). This only will come in bidding and watching screen */
    getIcons = (item, time) => {
        const flag = this.props.condition;
        let final = null;
        switch (flag) {
            case "watching":
                final = <div>
                    <div className="status-section d-flex align-items-center">
                        {
                            !this.getItemDetails(item)?.biddingstatus ?
                                null : <div className="d-flex align-items-center">
                                    {
                                        this.getItemDetails(item)?.biddingstatus === 'Winning' ?
                                            <div className="d-flex align-items-center won">
                                                <div className="icons">
                                                    <i className="fas fa-thumbs-up"></i>
                                                </div>
                                                <div>{this.getItemDetails(item)?.biddingstatus}</div>
                                            </div> :
                                            this.getItemDetails(item)?.biddingstatus === 'Not Winning' ?
                                                <div className="d-flex align-items-center not-won">
                                                    <div className="icons">
                                                        <i className="fas fa-thumbs-down"></i>
                                                    </div>
                                                    <div>{this.getItemDetails(item)?.biddingstatus}</div>
                                                </div> : null
                                    }
                                </div>
                        }
                    </div>
                </div>;
                break;
            case "bidding":
                final = <div className="status-section d-flex align-items-center">
                    {
                        this.getItemDetails(item)?.biddingstatus === "Won" ?
                            <div className="d-flex align-items-center won">
                                <div className="icons">
                                    <i className="fas fa-thumbs-up"></i>
                                </div>
                                <div>Winning</div>
                            </div> :
                            <div className="d-flex align-items-center not-won">
                                <div className="icons">
                                    <i className="fas fa-thumbs-down"></i>
                                </div>
                                <div>Not Winning</div>
                            </div>
                    }
                </div>;
                break;
            default:
                console.warn("Out of index");
        }
        return (final);
    }

    /** After delete item from watching or bidding screen, this function will call. */
    isItemRemoved = (itemIds = null) => {
        const itemId = itemIds ? itemIds : [this.state.clickedItem];
        const itemsDetailsGet = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "filter": [{ "field": "id", "value": [itemId], "op": "IN", "join": "AND" }],
        };
        /* Getting item details */
        ItemsService.getItemsList(itemsDetailsGet).then(
            itemsDetail => {
                const itemsDetails = itemsDetail.data.data;
                itemsDetails.forEach(x => {
                    const itemstatus = x.itemstatus;
                    if (itemstatus === "Pending") {
                        const itemsList = this.state.itemsList;
                        const index = itemsList.findIndex(y => y.id === x.id);
                        if (index !== -1) {
                            itemsList.splice(index, 1);
                            this.setState({
                                itemsList: itemsList
                            })
                        }
                    }
                });
            }
        );
    }

    /** Prevent open or refrsh page when click a tag */
    aTagHandle = (event) => {
        event.preventDefault();
    }

    /** Called when change tab. For handle auth, timer and bidding. */
    handleTabChange = () => {
        if (document.hidden) {
            // tab is now inactive// temporarily clear timer using clearInterval() / clearTimeout()
            clearInterval(this.countdownInterval);
        } else {
            // tab is active again// restart timers
            this.setState({
                notUpdated: true,
                timercal: 1
            }, () => {
                this.getUtc();
            });
        }
    }

    /**
     * To check item closed in backend.
     * 
     * @param {boolean} flag to call api
     * 
     * @param {string|number} itemid item id
     * 
     * @param {boolean} forceUpdate To call every 5 secs once API
     */
    updatedStatus = (flag, itemid, forceUpdate = false) => {
        if (flag) {
            if (!this.handleMultipleCall[itemid] || forceUpdate) {
                this.handleMultipleCall[itemid] = true;
                const data = {
                    "data": {
                        "itemIds": [itemid]
                    }
                }
                ItemsService.getCurrentBidValue(data).then(
                    res => {
                        const response = res.data.data[0];
                        if ('bidstatus' in response) {
                            if (response.bidstatus) {
                                this.setState({
                                    itemClosed: {
                                        ...this.state.itemClosed,
                                        [itemid]: true
                                    }
                                });
                            } else {
                                setTimeout(() => {
                                    this.updatedStatus(true, itemid, true);
                                }, 5000);
                            }
                        } else {
                            this.setState({
                                itemClosed: {
                                    ...this.state.itemClosed,
                                    [itemid]: true
                                }
                            });
                        }
                    }
                ).catch(
                    error => {
                        this.setState({
                            itemClosed: {
                                ...this.state.itemClosed,
                                [itemid]: true
                            }
                        });
                    }
                );
            }
        }
    }

    /** Last minute check */
    checkItClosedInBE = (item, time) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemClosed = this.state.itemClosed;
        let res = this.state.notUpdated ? "Checking Item Closing Time" : "Soft close in progress";

        if (item.itemstatus && item.itemstatus !== "Ready") {
            res =  item.itemstatus == "Pending" ? "Item not available" : "Item closed";
        } else {
            if (itemId in itemClosed) {
                res = this.state.itemClosed[itemId] ? "Item closed" : "Soft close in progress"
            }
        }

        return res;
    }


    /** Close model */
    onCloseSomethingWentWrongModal = () => this.setState({
        refreshData: {}
    })

    /** This will call when api throw error */
    onRefreshSomethingWentWrongModal = () => {
        const refreshFunction = this.state.refreshData?.func;
        const params = this.state.refreshData?.params;
        if (typeof refreshFunction === 'function' && Array.isArray(params)) {
            refreshFunction(...params)
        }
        this.onCloseSomethingWentWrongModal();
    }

    /** Scroll issue coming in firefox. For handle using this fun */
    cardItem = (items = {}, index = 0, rest = {}) => (
            <Col {...rest}>
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <div className="d-flex align-items-center justify-content-start">
                        {
                            this.props.showSelect ?
                                <div className={`custom-checkbox-div ${this.isChecked(items) ? 'checked' : ''}`} onClick={() => this.selectItem(items)}></div> : null
                        }
                        {this.props.showIcons ? this.getIcons(items, this.state.time) : null}
                    </div>
                </div>
                <div className={`pick-up visible ${items.isshippable === 0 ? 'pickup' : 'shippable'} d-flex align-items-center`}>
                    {
                        items.isshippable === 0 ?
                            <div className="image">
                                <img src={`${process.env.PUBLIC_URL}/static/images/Common/pickup.svg`} alt="pickup image"></img>
                            </div> :
                            <div className="image">
                                <img src={shippable} alt="shippable image"></img>
                            </div>
                    }
                    <div className="fz-12">
                        {
                            items.isshippable === 0 ? "Pick up only" : "Item is shippable"
                        }
                    </div>
                </div>
            </div>
            <div className="item-details clickable" ref={(ele) => { this[`itemsDetails${index}`] = ele }} onClick={() => this.overAllClick(items, index)}>
                <div className="d-flex flex-column justify-content-between">
                    <div className="header-content">
                        <div className="header-container">
                        <div className="image-container d-flex flex-column align-items-center justify-content-center">
                                {
                                    items.displayimageurl || items.thumbnailurl ?
                                        <img alt="item-image" src={ items.thumbnailurl ? items.thumbnailurl : items.displayimageurl ? items.displayimageurl : image_thumbnail } className="items-image"></img>
                                        : <div className="no-image d-flex flex-column align-items-center justify-content-center">
                                            <img alt="item-image" src={image_thumbnail} className="items-image"></img>
                                            {/* <span className="text-muted">No Image</span> */}
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="body-content">
                        <a href={getItemUrl(items.saleid, (items.id ? items.id : items.itemid), items.itemseourl)} onClick={this.aTagHandle}>
                            <div className="title d-flex flex-column justify-content-between">
                                <div className="section-one">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="top-address-section">
                                            {titleCase(items.city)}, {items.state}, {items.zipcode}
                                        </div>
                                        <div className="p-10">
                                            {
                                                items.itemtypeid ?
                                                    <div className="d-flex align-items-center">
                                                        {
                                                            items.itemtypeid ?
                                                                <div>
                                                                    <img alt="items-type" src={this.itemsImage[`item_image_${items.itemtypeid}`]} className="items-type"></img>
                                                                </div> : null
                                                        }
                                                        <div>
                                                            {items.itemtypename}
                                                        </div>
                                                    </div> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="items-title" ref={(ele) => this[`items_title_${index}`] = ele}>
                                        {items.title}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="footer-content">
                        <div className="d-flex justify-content-between h-100">
                            {
                                this.betweenCheck(items, this.state.time) || this.itmeIsClosed(items, this.state.time) || this.checkIsCheckTime(items.id ? items.id : items.itemid) || this.state.notUpdated ?
                                    <a href={getItemUrl(items.saleid, (items.id ? items.id : items.itemid), items.itemseourl)} className="d-flex align-items-end" onClick={this.aTagHandle}>
                                        <div className="closing-now d-flex flex-column justify-content-end">
                                            {
                                                this.state.notUpdated ? "Checking Item Closing Time" :
                                                    this.checkIsCheckTime(items.id ? items.id : items.itemid) ? "Soft close in progress" :
                                                        this.itmeIsClosed(items, this.state.time) ?
                                                            this.checkItClosedInBE(items, this.state.time) : "Less than a minute to bid"
                                            }
                                        </div>
                                    </a> : 
                                    items.itemclosetime ? 
                                    <a href={getItemUrl(items.saleid, (items.id ? items.id : items.itemid), items.itemseourl)} onClick={this.aTagHandle}>
                                        <div className={`duration ${this.durationBgColor(items, this.state.time)} d-flex flex-column justify-content-end h-100`}>
                                            <div className="count">
                                                <div className="day">
                                                    <div className="num">
                                                        <span>{minTwoDigits(getDays(this.countdown(items, this.state.time).asDays()))}</span>d
                                                    </div>
                                                </div>
                                                <div className="hr">
                                                    <div className="num">
                                                        <span>{minTwoDigits(this.countdown(items, this.state.time).hours())}</span>h
                                                    </div>
                                                </div>
                                                <div className="min">
                                                    <div className="num">
                                                        <span>{minTwoDigits(this.countdown(items, this.state.time).minutes())}</span>m
                                                    </div>
                                                </div>
                                                <div className="sec">
                                                    <div className="num">
                                                        <span>{minTwoDigits(this.countdown(items, this.state.time).seconds())}</span>s
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="no-of-days">
                                                {this.numberDaysInWord(items, this.state.time)}
                                            </div>
                                        </div>
                                    </a> : <div className='d-flex flex-column align-items-center justify-content-end p-3' style={{ color: "#ff5353" }}>Item not available</div>
                            }
                            <a href={getItemUrl(items.saleid, (items.id ? items.id : items.itemid), items.itemseourl)} aria-label={ "click to view " + `${items.itemseourl ? items.itemseourl : 'item'}` } className="remain-space" onClick={this.aTagHandle}>
                            </a>
                            <div style={{position: "relative"}} className="bid-now d-flex flex-column align-items-end justify-content-end h-100">
                              
                                { this.props.location.pathname === "/my-account/bidding" ?

                                    <div style={{whiteSpace: "nowrap", position: "absolute", top: "5px" }} className={`current-bid text-muted`}>

                                        My proxy bid: ${this.getItemDetails(items)?.maxproxyprice}

                                    </div> : null

                                }
                                <div  style={{whiteSpace: "nowrap", position: "absolute", top: "25px" }}  className={`text-success current-bid ${items.itemtypeid && (items.itemtypeid === 1 || items.itemtypeid === 3) ? 'invisible' : ''}`}>
                                    Current bid: {(this.state.getCurrentBidValueStatus === "SUCCESS" ? `$${parseFloat(this.getBidValue(items)).toFixed(2)}` :
                                        (this.state.getCurrentBidValueStatus === "REQUEST" ? <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img> : "--"))}
                                </div>
                                {
                                    this.itmeIsClosed(items, this.state.time) ? null :
                                        <Button size="sm"
                                            className={`${this.watching(items) ? 'btn-secondary' : 'btn-outline-primary watch-button'} d-flex align-items-center justify-content-between`}
                                            type="button" onClick={(event) => { this.watch(event, items, index) }}
                                            ref={(buttonDOM) => { this[`buttonDOM_${index}`] = buttonDOM; }}>Watch<i className="far fa-eye"></i></Button>
                                }
                                {
                                    this.itmeIsClosed(items, this.state.time) || items.itemtypeid === 3 ? null :
                                        <Button size="sm" className="bid-now-button d-flex align-items-center justify-content-between" type="button" disabled={items.itemclosetime == null}>
                                            {items.itemtypeid && items.itemtypeid === 1 ? 'Buy Now' : 'Bid Now'}
                                            <i className="fas fa-long-arrow-alt-right"></i></Button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Col>
    );

    /** Called when click more button */
    moreSale = () => {
        const location = this.props?.locationDetails;
        if (location) {
            disablePreviousState();
            const LocationUrl = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            this.props.history.push(LocationUrl);
        }
    }

    componentWillUnmount() {
        // clearInterval(this.getBidValueInterval);
        window.removeEventListener('resize', this.windowResizeHandle);
        clearInterval(this.countdownInterval);
        if (this.eventSource.length > 0) {
            this.eventSource.forEach(x => {
                if (x) {
                    x.close();
                }
            });
        }
        document.removeEventListener('visibilitychange', this.handleTabChange);
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    adSenseCallback = (id, status) => {
        this.adsenseFiller.removeAdsBasedOnStatusForMultipleAds(id, status, this.state.itemsList).then(data => {
            if ( data ) {
                this.setState({
                    itemsList: data,
                    // adStatusCallbackPending: false
                });
            } else {
                this.setState({
                    // adStatusCallbackPending: false
                })
            }
        });
    }

    render() {
        return (
            <div className={`${this.props.className ? this.props.className : ''} card-view-datatable`}>
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        <div ref={this.modalContainerRef} className="data-list">
                            {this.props.useVirtualized ?
                                <div >
                                    <AutoSizer disableHeight>
                                        {({ width }) => {
                                            const itemsPerRow = window.matchMedia("(max-width: 768px)")?.matches ? 1
                                                : window.matchMedia("(max-width: 1300px)")?.matches ? 2 : 3;
                                            const rowCount = Math.ceil(this.state.itemsList.length / itemsPerRow);
                                            const rowHeight = itemsPerRow === 1 ? 575 : 555;
                                            const rowWidth =width/ itemsPerRow;

                                            return (
                                                <List
                                                    autoHeight
                                                    width={width}
                                                    height={rowHeight}
                                                    rowCount={rowCount}
                                                    rowHeight={rowHeight}
                                                    scrollTop={this.props.virtualScrollTop}
                                                    overscanRowCount={5}
                                                    style={{ outline: "none" }}
                                                    rowRenderer={({
                                                        key,
                                                        index,
                                                        style,
                                                    }) => {
                                                        const itemList = [];
                                                        const fromIndex = index * itemsPerRow;
                                                        const toIndex = Math.min(fromIndex + itemsPerRow,
                                                            this.state.itemsList.length);

                                                        for (let i = fromIndex; i < toIndex; i++) {
                                                            itemList.push({ items: this.state.itemsList[i], index: i });
                                                        }

                                                        const adIndex = itemsPerRow === 2 ? itemList.length - 1 : 0;

                                                        return (
                                                            <div key={key} style={style}>
                                                                {
                                                                    itemsPerRow !== 2 && ADSENSE.ENABLE && this.props.showAd && itemList[adIndex].index !== 0 && itemList[adIndex].index % 15 === 0 ?
                                                                        <div style={{ maxWidth: '100%', flex: '100%', paddingBottom: "15px" }}>
                                                                            <Adsense googleAdCenter slotId={ADSENSE.ITEM_VIEW.slotId} />
                                                                        </div> : ''
                                                                }

                                                                <div className="d-flex">
                                                                    {React.Children.toArray(itemList.map(
                                                                        ({ items, index }) => {
                                                                            const restProps = {};
                                                                            restProps.style = { maxWidth: rowWidth };
                                                                            return (this.cardItem(items, index, restProps));
                                                                        }
                                                                    ))}
                                                                </div>

                                                                {
                                                                    itemsPerRow === 2 && ADSENSE.ENABLE && this.props.showAd && itemList[adIndex].index !== 0 && itemList[adIndex].index % 15 === 0 ?
                                                                        <div style={{ maxWidth: '100%', flex: '100%', paddingBottom: "15px" }}>
                                                                            <Adsense googleAdCenter slotId={ADSENSE.ITEM_VIEW.slotId} />
                                                                        </div> : ''
                                                                }
                                                            </div >
                                                        );
                                                    }
                                                    }
                                                />
                                            )
                                        }}
                                    </AutoSizer>
                                </div>
                                :
                                <Row xs={1} sm={1} md={1} lg={this.noOfCloumnGet()}>
                                    {
                                        React.Children.toArray(this.state.itemsList.map((items, index) => 
                                            <>
                                                {
                                                    ADSENSE.ENABLE && this.props.showAd && index !== 0 && index % 15 === 0 ? <Adsense googleAdCenter slotId={ADSENSE.ITEM_SEARCH.slotId} /> : ''
                                                }

                                                { this.cardItem(items, index) }
                                            </>
                                        ))
                                    }
                                </Row>
                            }
                            {
                                this.state.nextList && this.props.showMoreButton ?
                                    <div className="d-flex justify-content-center">
                                        <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.getMoreList}>
                                            More {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                        </div>
                                    </div> : null
                            }
                            {
                                this.state.itemsList.length === 0 ?
                                    <div className="no-data-found">

                                        {this.props?.locationDetails?.salecount && this.props?.locationDetails?.salecount > 0 && !this.props?.categoryCount?.orginal?.[0]?.count > 0 ?
                                            <div className="button-center">
                                                <div className="normal-button clickable" onClick={this.moreSale}>
                                                    More Sales from this Location
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {this.props.addEstateBidPrice ?
                                                    <>
                                                        <div className="text-center h4 text-bold">
                                                            You have great taste! This amazing CTBids auction does not have any listings for {this.props.categoryName}. Browse other categories in this estate sales now!
                                                        </div>
                                                        {/* <div className="text-center text-muted h5">
                                                            <Button onClick={() => { this.props.history.push('/'); }}>Shop CTBIDS</Button>
                                                        </div> */}
                                                    </> :
                                                    <>
                                                        <div className="text-center no-data-search-icon">
                                                            <i className="fas fa-search fa-3x"></i>
                                                        </div><div className="text-center h4 text-bold">
                                                            No results found
                                                        </div><div className="text-center text-muted h5">
                                                            We couldn't find what you're looking for.
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        }
                                    </div> : null
                            }
                        </div>
                }
                <Modal centered show={this.state.askConfirmForWatch} animation={false} backdrop="static">
                    <Modal.Body>
                        <div className="unwatch-confirmation">
                            {/* <div className="header">
                                Watching
                            </div> */}
                            <div className="text-center">
                                Are you sure, you want to stop watching ?
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>No</Button>
                            <Button variant="secondary mx-2" onClick={() => this.removeFromWatch(true)} disabled={this.state.confirmLoader}>
                                Yes {' '} {this.state.confirmLoader ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> : null}
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered
                    animation={false}
                    backdrop="static"
                    enforceFocus={false}
                    backdropClassName="refresh-modal-backdrop"
                    show={!this.props.sessionModal && this.state.refreshData?.showModal}
                    container={this.props.modalWithContainer && this.modalContainerRef}
                >
                    <Modal.Body >
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Oops, something went wrong... {isAuthorized() ? "Try to refresh the page, or log out and log in again." : "Try to refresh the page."}
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" onClick={this.onCloseSomethingWentWrongModal}>Cancel</Button>
                                <Button variant="secondary mx-2" onClick={this.onRefreshSomethingWentWrongModal}>Refresh</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
